import { useFilterApply } from '@/components/data-table/data-table-store-sync'
import { Button } from '@/components/ui/button'
import { Search } from 'lucide-react'

/**
 * Applies the filter panel's draft to the query on click. Filters are staged as
 * the user edits them and only run when this button is pressed (or Enter in a
 * search input) — never on keystroke — so a partial/expensive search never
 * fires mid-edit.
 */
export function DataTableFilterApplyButton({
  onApplied,
}: {
  onApplied?: () => void
}) {
  const { applyFilters, isDirty } = useFilterApply()

  return (
    <Button
      type="button"
      variant="default"
      className="w-full gap-2"
      disabled={!isDirty}
      onClick={() => {
        applyFilters()
        onApplied?.()
      }}>
      <Search className="h-4 w-4" />
      Search
    </Button>
  )
}
